<template>
    <div>
        <DetailGadaiKomp :detailGadai="dataPenarikan" />
        <div class="detail-data-wrapper">
            <h6 class="form-title">DATA FOTO PENARIKAN</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Foto Penarikan</b-col>
                <b-col>
                    <a v-bind:href="$baseFilePath+dataFotoPenarikan" target="_blank">
                        <img width="150px" :src="$baseFilePath+dataFotoPenarikan" alt="Foto Penarikan">
                    </a>
                    <span class="file-name mt-2"></span>
                </b-col>
            </b-row>
        </div>

    </div>
</template>

<script>
import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-penarikan',
    components: {
        DetailGadaiKomp,
    },
    props: {
        dataPenarikan: { type: Object, required: true },
        dataFotoPenarikan: { type: String, required: true }
    },
    
}
</script>
